import React from "react";

const CustomAlert = ({ type, children, onClose }) => {
  return (
    <>
      <div className={`alert alert-${type}`} role="alert" id="alert">
        {children}
        <button
          style={{
            backgroundColor: "transparent",
            border: "0px",
            float: "right",
          }}
          type="button"
          className="close"
          data-dismiss="alert"
          aria-label="Close"
          onClick={() => onClose && onClose()}
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
    </>
  );
};

export default CustomAlert;
